<template>
  <div class="products">

    <!-- Category Selection -->
    <section class="product-categories py-8">
      <div class="container">
<!--        <div class="section-header text-center reveal">-->
<!--          <span class="section-tag">-->
<!--            <i class="fas fa-th-large mr-2"></i>产品分类-->
<!--          </span>-->
<!--          <h2 class="section-title">浏览我们的产品</h2>-->
<!--          <p class="section-subtitle">专业的焊接防护产品，满足不同工作需求</p>-->
<!--        </div>-->

<!--        <div class="categories-grid">-->
<!--          <div-->
<!--            class="category-card reveal-scale"-->
<!--            v-for="(category, index) in categories"-->
<!--            :key="category.id"-->
<!--            :class="{ active: selectedCategory === category.id }"-->
<!--            :style="{ transitionDelay: (index * 0.1) + 's' }"-->
<!--            @click="selectCategory(category.id)"-->
<!--          >-->
<!--            <div class="category-icon">-->
<!--              <i :class="category.icon"></i>-->
<!--              <div class="icon-shine"></div>-->
<!--            </div>-->
<!--            <h3 class="category-name">{{ category.name }}</h3>-->
<!--            <p class="category-count">{{ category.count }}款产品</p>-->
<!--            <div class="category-indicator">-->
<!--              <i class="fas fa-arrow-right"></i>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </section>

    <!-- Product List -->
    <section class="product-list py-8 bg-light">
      <div class="container">
        <div class="section-header text-center reveal">
          <span class="section-tag">
            <i class="fas fa-box-open mr-2"></i>{{ $t('products.listTitle') }}
          </span>
          <h2 class="section-title">{{ currentCategoryName }}</h2>
          <p class="section-subtitle">{{ currentCategoryDesc }}</p>
        </div>

        <div class="products-grid">
          <div
            class="product-card reveal-scale"
            v-for="(product, index) in filteredProducts"
            :key="product.id"
            :style="{ transitionDelay: ((index % 4) * 0.1) + 's' }"
          >
            <div class="product-image">
              <img :src="product.image" :alt="product.name">
              <div class="product-badges">
                <span class="badge badge-hot">{{ $t('products.hot') }}</span>
              </div>
              <div class="product-overlay">
                <button class="btn btn-light" @click="viewProduct(product)">
                  <i class="fas fa-eye mr-2"></i>{{ $t('products.viewDetail') }}
                </button>
              </div>
            </div>
            <div class="product-content">
              <h4 class="product-name">{{ $t(product.nameKey) }}</h4>
              <p class="product-desc">{{ $t(product.descKey) }}</p>
              <div class="product-specs">
                <span class="spec-tag" v-for="(specKey, index) in product.specsKeys" :key="index">
                  <i class="fas fa-check mr-1"></i>{{ $t(specKey) }}
                </span>
              </div>
              <div class="product-actions">
                <button class="btn btn-primary btn-block" @click="getQuote(product)">
                  <i class="fas fa-paper-plane mr-2"></i>{{ $t('products.contactUs') }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div v-if="filteredProducts.length === 0" class="empty-state reveal">
          <i class="fas fa-box-open fa-4x"></i>
          <h3>{{ $t('products.emptyTitle') }}</h3>
          <p>{{ $t('products.emptyDesc') }}</p>
        </div>
      </div>
    </section>

    <!-- Features Section -->
    <section class="features-section py-8">
      <div class="container">
        <div class="section-header text-center reveal">
          <span class="section-tag section-tag-light">
            <i class="fas fa-star mr-2"></i>{{ $t('products.features.title') }}
          </span>
          <h2 class="section-title section-title-light">{{ $t('products.features.subtitle') }}</h2>
        </div>

        <div class="features-grid">
          <div class="feature-item reveal" v-for="(feature, index) in features" :key="index" :style="{ transitionDelay: (index * 0.15) + 's' }">
            <div class="feature-icon">
              <i :class="feature.icon"></i>
            </div>
            <h4 class="feature-title">{{ $t(feature.titleKey) }}</h4>
            <p class="feature-desc">{{ $t(feature.descKey) }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="cta-section py-8">
      <div class="container">
        <div class="cta-wrapper reveal-scale">
          <div class="cta-content">
            <h2>{{ $t('products.cta.title') }}</h2>
            <p>{{ $t('products.cta.desc') }}</p>
            <div class="cta-buttons">
              <a href="/contact" class="btn btn-primary btn-lg">
                <i class="fas fa-headset mr-2"></i>{{ $t('products.contactUs') }}
              </a>
<!--              <a href="https://wa.me/8615163903660" target="_blank" class="btn btn-outline-primary btn-lg">-->
<!--                <i class="fab fa-whatsapp mr-2"></i>WhatsApp咨询-->
<!--              </a>-->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Product Modal -->
    <div class="product-modal" v-if="showModal" @click.self="closeModal">
      <div class="modal-content">
        <button class="modal-close" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>
        <div class="modal-body" v-if="selectedProduct">
          <div class="modal-image">
            <img :src="selectedProduct.image" :alt="selectedProduct.name">
          </div>
          <div class="modal-info">
            <h3>{{ $t(selectedProduct.nameKey) }}</h3>
            <p class="modal-desc">{{ $t(selectedProduct.descKey) }}</p>
            <div class="modal-specs">
              <h5>{{ $t('products.modal.specs') }}</h5>
              <ul>
                <li v-for="(specKey, index) in selectedProduct.specsKeys" :key="index">
                  <i class="fas fa-check-circle"></i>{{ $t(specKey) }}
                </li>
              </ul>
            </div>
            <a href="/contact" class="btn btn-primary mt-4">
              <i class="fas fa-paper-plane mr-2"></i>{{ $t('products.modal.contactUs') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Products',
  data() {
    return {
      parallaxOffset: 0,
      pageLoaded: false,
      showModal: false,
      selectedProduct: null,
      selectedCategory: 'welding-glasses',
      categories: [
        { id: 'welding-glasses', nameKey: 'products.categories.weldingGlasses', count: 6, icon: 'fas fa-glasses' },
        { id: 'safety-glasses', nameKey: 'products.categories.safetyGlasses', count: 2, icon: 'fas fa-eye' },
        { id: 'welding-mask', nameKey: 'products.categories.weldingMask', count: 3, icon: 'fas fa-hard-hat' },
        { id: 'protective-gear', nameKey: 'products.categories.protectiveGear', count: 4, icon: 'fas fa-shield-alt' }
      ],
      products: [
        {
          id: 1,
          category: 'welding-glasses',
          nameKey: 'products.items.1.name',
          descKey: 'products.items.1.desc',
          specsKeys: ['products.items.1.specs.0', 'products.items.1.specs.1', 'products.items.1.specs.2', 'products.items.1.specs.3'],
          image: 'https://1500062809.vod-qcloud.com/6d053ea1vodcq1500062809/0e76e2d55001834810618162136/dGZcpXmt92UA.jpg'
        },
        {
          id: 2,
          category: 'welding-glasses',
          nameKey: 'products.items.2.name',
          descKey: 'products.items.2.desc',
          specsKeys: ['products.items.2.specs.0', 'products.items.2.specs.1', 'products.items.2.specs.2', 'products.items.2.specs.3'],
          image: 'https://1500062809.vod-qcloud.com/6d053ea1vodcq1500062809/b92b4c625001834810610944995/menOyPifDyYA.jpg'
        },
        {
          id: 3,
          category: 'welding-glasses',
          nameKey: 'products.items.3.name',
          descKey: 'products.items.3.desc',
          specsKeys: ['products.items.3.specs.0', 'products.items.3.specs.1', 'products.items.3.specs.2', 'products.items.3.specs.3'],
          image: 'https://1500062809.vod-qcloud.com/6d053ea1vodcq1500062809/0e68bb255001834810618159785/Af9HA4KETFIA.jpg'
        },
        {
          id: 4,
          category: 'welding-glasses',
          nameKey: 'products.items.4.name',
          descKey: 'products.items.4.desc',
          specsKeys: ['products.items.4.specs.0', 'products.items.4.specs.1', 'products.items.4.specs.2', 'products.items.4.specs.3'],
          image: 'https://1500062809.vod-qcloud.com/6d053ea1vodcq1500062809/075bbc405001834810598618332/HBSKrjfUdMcA.jpg'
        }
      ],
      features: [
        { icon: 'fas fa-certificate', titleKey: 'products.features.items.quality.title', descKey: 'products.features.items.quality.desc' },
        { icon: 'fas fa-shipping-fast', titleKey: 'products.features.items.shipping.title', descKey: 'products.features.items.shipping.desc' },
        { icon: 'fas fa-tools', titleKey: 'products.features.items.support.title', descKey: 'products.features.items.support.desc' },
        { icon: 'fas fa-hand-holding-heart', titleKey: 'products.features.items.service.title', descKey: 'products.features.items.service.desc' }
      ]
    }
  },
  computed: {
    filteredProducts() {
      return this.products.filter(product => product.category === this.selectedCategory)
    },
    currentCategoryName() {
      const category = this.categories.find(c => c.id === this.selectedCategory)
      return category ? this.$t(category.nameKey) : ''
    },
    currentCategoryDesc() {
      const descMap = {
        'welding-glasses': 'products.categoryDesc.weldingGlasses',
        'safety-glasses': 'products.categoryDesc.safetyGlasses',
        'welding-mask': 'products.categoryDesc.weldingMask',
        'protective-gear': 'products.categoryDesc.protectiveGear'
      }
      return this.$t(descMap[this.selectedCategory]) || ''
    }
  },
  mounted() {
    setTimeout(() => {
      this.pageLoaded = true
    }, 200)

    window.addEventListener('scroll', this.handleScroll)
    this.initRevealAnimations()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.parallaxOffset = window.scrollY * 0.3
    },
    selectCategory(id) {
      this.selectedCategory = id
    },
    viewProduct(product) {
      this.selectedProduct = product
      this.showModal = true
      document.body.style.overflow = 'hidden'
    },
    closeModal() {
      this.showModal = false
      this.selectedProduct = null
      document.body.style.overflow = ''
    },
    getQuote(product) {
      this.selectedProduct = product
      this.showModal = true
      document.body.style.overflow = 'hidden'
    },
    initRevealAnimations() {
      const reveals = document.querySelectorAll('.reveal, .reveal-scale')

      const revealOnScroll = () => {
        reveals.forEach(element => {
          const windowHeight = window.innerHeight
          const elementTop = element.getBoundingClientRect().top
          const revealPoint = 100

          if (elementTop < windowHeight - revealPoint) {
            element.classList.add('active')
          }
        })
      }

      window.addEventListener('scroll', revealOnScroll)
      window.addEventListener('load', revealOnScroll)

      revealOnScroll()
    }
  }
}
</script>

<style scoped>
.products {
  padding-top: 0;
}

/* Page Header */
.page-header {
  position: relative;
  height: 400px;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.page-header-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 120%;
  background: linear-gradient(135deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.5) 100%),
              url('https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=Industrial%20safety%20equipment%20product%20display%20background&image_size=landscape_16_9');
  background-size: cover;
  background-position: center;
  will-change: transform;
}

.page-header-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(ellipse at center, transparent 0%, rgba(0,0,0,0.4) 100%);
}

.page-header-content {
  position: relative;
  z-index: 2;
  width: 100%;
}

.page-header-text {
  text-align: center;
  color: white;
}

.page-title {
  font-size: 3.5rem;
  font-weight: 800;
  margin-bottom: 15px;
}

.page-title span {
  display: inline-block;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-title.animate-in span {
  opacity: 1;
  transform: translateY(0);
}

.page-subtitle {
  font-size: 1.2rem;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.8s ease;
  transition-delay: 0.3s;
}

.page-subtitle.animate-in {
  opacity: 0.9;
  transform: translateY(0);
}

.page-breadcrumb {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(0,0,0,0.3);
  padding: 15px 0;
}

.breadcrumb {
  background: none;
  margin: 0;
  padding: 0;
}

.breadcrumb-item a {
  color: rgba(255,255,255,0.8);
  text-decoration: none;
  transition: color 0.3s;
}

.breadcrumb-item a:hover {
  color: white;
}

.breadcrumb-item.active {
  color: rgba(255,255,255,0.6);
}

.breadcrumb-item + .breadcrumb-item::before {
  color: rgba(255,255,255,0.5);
}

/* Section Styles */
.section-tag {
  display: inline-block;
  padding: 8px 20px;
  background: linear-gradient(135deg, #fff5f5, #ffebee);
  color: #e53935;
  border-radius: 25px;
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 15px;
}

.section-tag-light {
  background: linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.1));
  color: white;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
}

.section-title-light {
  color: white;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #7f8c8d;
  margin-bottom: 50px;
}

/* Categories Grid */
.categories-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
}

.category-card {
  background: white;
  padding: 35px 25px;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.category-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(229, 57, 53, 0.05), transparent);
  opacity: 0;
  transition: opacity 0.3s;
}

.category-card:hover::before,
.category-card.active::before {
  opacity: 1;
}

.category-card:hover,
.category-card.active {
  transform: translateY(-8px);
  box-shadow: 0 20px 50px rgba(229, 57, 53, 0.15);
  border-color: #e53935;
}

.category-icon {
  width: 90px;
  height: 90px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #fff5f5, #ffebee);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  color: #e53935;
  position: relative;
  transition: all 0.4s ease;
  overflow: hidden;
}

.category-icon .icon-shine {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent,
    rgba(255,255,255,0.3),
    transparent
  );
  transform: rotate(45deg);
  opacity: 0;
  transition: opacity 0.3s;
}

.category-card:hover .icon-shine {
  animation: shine 1s;
}

@keyframes shine {
  0% { opacity: 0; transform: rotate(45deg) translateX(-100%); }
  50% { opacity: 1; }
  100% { opacity: 0; transform: rotate(45deg) translateX(100%); }
}

.category-card.active .category-icon,
.category-card:hover .category-icon {
  background: linear-gradient(135deg, #e53935, #c62828);
  color: white;
}

.category-name {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.category-count {
  font-size: 0.9rem;
  color: #888;
  margin-bottom: 15px;
}

.category-indicator {
  width: 40px;
  height: 40px;
  margin: 0 auto;
  background: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e53935;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.3s ease;
}

.category-card:hover .category-indicator,
.category-card.active .category-indicator {
  opacity: 1;
  transform: translateY(0);
}

/* Products Grid */
.products-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.product-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0,0,0,0.05);
  border: 1px solid #f0f0f0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.product-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0,0,0,0.1);
}

.product-image {
  position: relative;
  height: 220px;
  overflow: hidden;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.product-card:hover .product-image img {
  transform: scale(1.1);
}

.product-badges {
  position: absolute;
  top: 15px;
  left: 15px;
}

.badge-hot {
  background: linear-gradient(135deg, #e53935, #c62828);
  color: white;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
}

.product-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.product-card:hover .product-overlay {
  opacity: 1;
}

.product-content {
  padding: 25px;
}

.product-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.product-desc {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-specs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}

.spec-tag {
  font-size: 0.8rem;
  padding: 4px 10px;
  background: #fff5f5;
  color: #e53935;
  border-radius: 15px;
  display: inline-flex;
  align-items: center;
}

.spec-tag i {
  font-size: 0.7rem;
}

/* Features Section */
.features-section {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.feature-item {
  text-align: center;
  padding: 40px 20px;
  background: rgba(255,255,255,0.05);
  border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.1);
  transition: all 0.3s ease;
}

.feature-item:hover {
  background: rgba(255,255,255,0.1);
  transform: translateY(-5px);
}

.feature-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #e53935, #c62828);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  color: white;
}

.feature-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  margin-bottom: 10px;
}

.feature-desc {
  font-size: 0.9rem;
  color: rgba(255,255,255,0.7);
  margin: 0;
}

/* CTA Section */
.cta-wrapper {
  background: linear-gradient(135deg, #e53935, #c62828);
  border-radius: 24px;
  padding: 60px;
  text-align: center;
  color: white;
}

.cta-content h2 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 15px;
}

.cta-content p {
  font-size: 1.1rem;
  opacity: 0.9;
  margin-bottom: 30px;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
}

.cta-buttons .btn-primary {
  background: white;
  color: #e53935;
  border: none;
}

.cta-buttons .btn-primary:hover {
  background: #f5f5f5;
  color: #c62828;
}

.cta-buttons .btn-outline-primary {
  border: 2px solid white;
  color: white;
  background: transparent;
}

.cta-buttons .btn-outline-primary:hover {
  background: white;
  color: #e53935;
}

/* Modal */
.product-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 24px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  background: #f8f9fa;
  border: none;
  border-radius: 50%;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.3s;
  z-index: 10;
}

.modal-close:hover {
  background: #e53935;
  color: white;
}

.modal-body {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.modal-image {
  padding: 30px;
}

.modal-image img {
  width: 100%;
  border-radius: 16px;
}

.modal-info {
  padding: 30px;
}

.modal-info h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.modal-desc {
  color: #666;
  line-height: 1.7;
  margin-bottom: 25px;
}

.modal-specs h5 {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.modal-specs ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.modal-specs li {
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.modal-specs li i {
  color: #e53935;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #888;
}

.empty-state i {
  margin-bottom: 20px;
  opacity: 0.5;
}

.empty-state h3 {
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: #666;
}

/* Utilities */
.py-8 {
  padding-top: 80px;
  padding-bottom: 80px;
}

/* Reveal Animations */
.reveal, .reveal-scale {
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.reveal {
  transform: translateY(30px);
}

.reveal-scale {
  transform: scale(0.9);
}

.reveal.active, .reveal-scale.active {
  opacity: 1;
  transform: translate(0) scale(1);
}

/* Responsive */
@media (max-width: 991px) {
  .categories-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .products-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .modal-body {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .page-title {
    font-size: 2.5rem;
  }

  .categories-grid {
    grid-template-columns: 1fr;
  }

  .products-grid {
    grid-template-columns: 1fr;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .cta-buttons {
    flex-direction: column;
  }

  .cta-wrapper {
    padding: 40px 20px;
  }
}
</style>
